
import React from "react";
import * as react from "react";
import { map, defaultArg } from "../../../fable_modules/fable-library-js.5.0.0/Option.js";
import { FSharpMap__TryFind } from "../../../fable_modules/fable-library-js.5.0.0/Map.js";
import { empty } from "../../../fable_modules/fable-library-js.5.0.0/List.js";
import { Spacing } from "@stenajs-webui/core";

export function SpacingModule_View($props) {
    const p = $props.p;
    const props = {};
    const children = defaultArg(map((x) => x, FSharpMap__TryFind(p, "children")), empty());
    return react.createElement(Spacing, props, ...children);
}

